import { render, staticRenderFns } from "./sidebar-slider.vue?vue&type=template&id=2404e58c"
import script from "./sidebar-slider.vue?vue&type=script&lang=js"
export * from "./sidebar-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports